<template>
  <v-dialog
    :value="isDeletarSecaoDialogOpen"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="headline">
        Deletar seção
      </v-card-title>

      <v-card-text>
        Tem certeza que deseja deletar a seção?
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="closeDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click="confirmarDeleteSecao"
        >
          <v-progress-circular
            v-if="loading"
            class="mx-3"
            indeterminate
            color="secundary"
          >
          </v-progress-circular>
          <span v-else>ok</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import router from '@/router'
import FormularioService from '@/services/modules/FormularioService'

export default {
  model: {
    prop: 'isDeletarSecaoDialogOpen',
    event: 'update:is-deletar-secao-dialog-open',
  },

  props: {
    isDeletarSecaoDialogOpen: {
      type: Boolean,
      required: true,
    },
    secaoId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const loading = ref(false)

    const successCallback = () => {
      emit('secao-removida')
      setTimeout(() => {
        loading.value = false
      }, 1000)
    }
    const failureCallback = () => {
      loading.value = false
    }
    const closeDialog = () => emit('update:is-deletar-secao-dialog-open', false)

    const confirmarDeleteSecao = async () => {
      loading.value = true

      try {
        await FormularioService.deletarSecao(router.currentRoute.params.id, props.secaoId)
        successCallback()
      } catch {
        failureCallback()
      } finally {
        closeDialog()
      }
    }

    return {
      loading,
      closeDialog,
      confirmarDeleteSecao,
    }
  },
}
</script>
